import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5 } from "styled-components";
var _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import dateFormat from "dateformat";
import { runInAction } from "mobx";
import { observer } from "mobx-react";
import { Component } from "react";
import { withTranslation } from "react-i18next";
import styled, { withTheme } from "styled-components";
import JulianDate from "terriajs-cesium/Source/Core/JulianDate";
import isDefined from "../../../Core/isDefined";
import CommonStrata from "../../../Models/Definition/CommonStrata";
import Box from "../../../Styled/Box";
import { RawButton } from "../../../Styled/Button";
import { GLYPHS, StyledIcon } from "../../../Styled/Icon";
import Spacing from "../../../Styled/Spacing";
import Text, { TextSpan } from "../../../Styled/Text";
import { formatDateTime } from "../../BottomDock/Timeline/DateFormats";
import DateTimePicker from "../../BottomDock/Timeline/DateTimePicker";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
let DateTimeSelectorSection = observer(_class = class DateTimeSelectorSection extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "state", {
      isOpen: false
    });
    this.changeDateTime = this.changeDateTime.bind(this);
    this.onTimelineButtonClicked = this.onTimelineButtonClicked.bind(this);
    this.onShowOnChartButtonClicked = this.onShowOnChartButtonClicked.bind(this);
    this.onPreviousButtonClicked = this.onPreviousButtonClicked.bind(this);
    this.onNextButtonClicked = this.onNextButtonClicked.bind(this);
    this.onOpen = this.onOpen.bind(this);
    this.onClose = this.onClose.bind(this);
    this.toggleOpen = this.toggleOpen.bind(this);
  }
  changeDateTime(time) {
    const item = this.props.item;

    // Give this item focus on the timeline (if it is connected to the timeline), so that the user can select all available dates for this item.
    item.terria.timelineStack.promoteToTop(item);
    runInAction(() => {
      // Set the time on the item, set it to use its own clock, update the imagery and repaint.
      item.setTrait(CommonStrata.user, "currentTime", JulianDate.toIso8601(JulianDate.fromDate(time)));
    });
    item.terria.currentViewer.notifyRepaintRequired();
  }
  onTimelineButtonClicked() {
    const item = this.props.item;
    const terria = item.terria;
    if (terria.timelineStack.items.indexOf(item) >= 0) {
      terria.timelineStack.remove(item);
    } else {
      terria.timelineStack.addToTop(item);
    }
    item.terria.currentViewer.notifyRepaintRequired();
  }
  onShowOnChartButtonClicked() {
    const item = this.props.item;
    runInAction(() => {
      item.setTrait(CommonStrata.user, "showInChartPanel", !item.showInChartPanel);
    });
  }
  onPreviousButtonClicked() {
    const item = this.props.item;

    // Give this item focus on the timeline (if it is connected to the timeline), so that the user can select all available dates for this item.
    item.terria.timelineStack.promoteToTop(item);
    item.moveToPreviousDiscreteTime(CommonStrata.user);

    // Repaint imagery on layers that don't subscribe to clock changes.
    item.terria.currentViewer.notifyRepaintRequired();
  }
  onNextButtonClicked() {
    const item = this.props.item;

    // Give this item focus on the timeline (if it is connected to the timeline), so that the user can select all available dates for this item.
    item.terria.timelineStack.promoteToTop(item);
    item.moveToNextDiscreteTime(CommonStrata.user);

    // Repaint imagery on layers that don't subscribe to clock changes.
    item.terria.currentViewer.notifyRepaintRequired();
  }
  onOpen() {
    this.setState({
      isOpen: true
    });
  }
  onClose() {
    this.setState({
      isOpen: false
    });
  }
  toggleOpen(event) {
    this.setState({
      isOpen: !this.state.isOpen
    });
    event.stopPropagation();
  }
  render() {
    var _item$timeLabel;
    const {
      t
    } = this.props;
    let discreteTime;
    let format;
    const item = this.props.item;
    const discreteTimes = item.discreteTimesAsSortedJulianDates;
    const disableDateTimeSelector = item.disableDateTimeSelector;
    if (!isDefined(discreteTimes) || discreteTimes.length === 0 || disableDateTimeSelector) {
      return null;
    }
    if (isDefined(item.currentDiscreteJulianDate)) {
      const time = JulianDate.toDate(item.currentDiscreteJulianDate);
      if (isDefined(item.dateFormat)) {
        format = item.dateFormat;
        discreteTime = dateFormat(time, item.dateFormat);
      } else {
        discreteTime = formatDateTime(time);
      }
    }
    const attachedToTimeline = item.terria.timelineStack.contains(item);
    return /*#__PURE__*/_jsxs(Box, {
      column: true,
      paddedVertically: true,
      children: [/*#__PURE__*/_jsx(Text, {
        medium: true,
        textLight: true,
        id: "dateTimeSelectorLabel",
        children: (_item$timeLabel = item.timeLabel) !== null && _item$timeLabel !== void 0 ? _item$timeLabel : t("dateTime.selectorLabel")
      }), /*#__PURE__*/_jsx(Spacing, {
        bottom: 1
      }), /*#__PURE__*/_jsxs(Box, {
        fullWidth: true,
        justifySpaceBetween: true,
        styledHeight: "40px",
        gap: true,
        children: [/*#__PURE__*/_jsxs(_StyledBox, {
          backgroundColor: this.props.theme.darkLighter,
          children: [/*#__PURE__*/_jsx(_StyledStyledButton, {
            disabled: !item.isPreviousDiscreteTimeAvailable,
            onClick: this.onPreviousButtonClicked,
            title: t("dateTime.previous"),
            children: /*#__PURE__*/_jsx(StyledIcon, {
              fillColor: this.props.theme.grey,
              glyph: GLYPHS.previous,
              styledWidth: "8px"
            })
          }), /*#__PURE__*/_jsx(_StyledStyledButton2, {
            onClick: this.toggleOpen,
            title: t("dateTime.selectTime"),
            id: "current-date-btn",
            children: /*#__PURE__*/_jsx(TextSpan, {
              textLight: true,
              id: "current-date",
              children: isDefined(discreteTime) ? discreteTime : t("dateTime.outOfRange")
            })
          }), /*#__PURE__*/_jsx(_StyledStyledButton3, {
            disabled: !item.isNextDiscreteTimeAvailable,
            onClick: this.onNextButtonClicked,
            title: t("dateTime.next"),
            children: /*#__PURE__*/_jsx(StyledIcon, {
              glyph: GLYPHS.next,
              styledWidth: "8px"
            })
          }), /*#__PURE__*/_jsx(_StyledDiv, {
            title: t("dateTime.selectTime"),
            children: /*#__PURE__*/_jsx(DateTimePicker, {
              currentDate: item.currentDiscreteJulianDate === undefined ? undefined : JulianDate.toDate(item.currentDiscreteJulianDate),
              dates: item.objectifiedDates,
              onChange: this.changeDateTime,
              openDirection: "down",
              isOpen: this.state.isOpen,
              onClose: this.onClose,
              dateFormat: format
            })
          })]
        }), /*#__PURE__*/_jsx(TimelineButton, {
          active: attachedToTimeline,
          type: "button",
          onClick: this.onTimelineButtonClicked,
          title: t("dateTime.useTimeline"),
          children: /*#__PURE__*/_jsx(StyledIcon, {
            light: true,
            styledWidth: "20px",
            glyph: GLYPHS.timeline
          })
        }), /*#__PURE__*/_jsx(TimelineButton, {
          active: item.showInChartPanel,
          type: "button",
          onClick: this.onShowOnChartButtonClicked,
          title: t("dateTime.availableTimeChart"),
          children: /*#__PURE__*/_jsx(StyledIcon, {
            light: true,
            styledWidth: "20px",
            glyph: GLYPHS.lineChart
          })
        })]
      })]
    });
  }
}) || _class;
const StyledButton = styled(RawButton).withConfig({
  displayName: "DateTimeSelectorSection__StyledButton",
  componentId: "sc-1ncmtig-0"
})(["padding:10px;", ""], props => props.disabled && "&[disabled],\n    &[disabled]:hover,\n    &[disabled]:focus {\n      opacity: 0.4;\n      cursor: default;\n      outline: 0;\n      background: rgba(250, 250, 250, 0.2);\n    }\n  ");
var _StyledStyledButton3 = styled(StyledButton).withConfig({
  displayName: "DateTimeSelectorSection___StyledStyledButton3",
  componentId: "sc-1ncmtig-1"
})(["border-left:1px solid rgba(255,255,255,0.15);border-radius:0 2px 2px 0;"]);
var _StyledStyledButton2 = styled(StyledButton).withConfig({
  displayName: "DateTimeSelectorSection___StyledStyledButton2",
  componentId: "sc-1ncmtig-2"
})(["flex-grow:1;padding:0 10px;"]);
var _StyledStyledButton = styled(StyledButton).withConfig({
  displayName: "DateTimeSelectorSection___StyledStyledButton",
  componentId: "sc-1ncmtig-3"
})(["border-right:1px solid rgba(255,255,255,0.15);border-radius:2px 0 0 2px;"]);
const TimelineButton = styled(RawButton).withConfig({
  displayName: "DateTimeSelectorSection__TimelineButton",
  componentId: "sc-1ncmtig-4"
})(["padding:0 5px;border-radius:2px;background-color:rgba(250,250,250,0.2);", ""], props => props.active && "\n      background-color: ".concat(props.theme.colorPrimary, ";\n      color: ").concat(props.theme.textLight, ";\n      &:hover,\n      &:focus {\n        color: ").concat(props.theme.textLight, ";\n      }\n  "));
export default withTranslation()(withTheme(DateTimeSelectorSection));
var _StyledBox = styled(Box).withConfig({
  displayName: "DateTimeSelectorSection___StyledBox",
  componentId: "sc-1ncmtig-5"
})(["border-radius:2px;flex-grow:1;"]);
var _StyledDiv = styled("div").withConfig({
  displayName: "DateTimeSelectorSection___StyledDiv",
  componentId: "sc-1ncmtig-6"
})(["width:0;height:0;"]);